import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import HomeTestingUsersTable from './HomeTestingUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyHomeTestingUsers } from './companyHomeTestingApi';

/**
 * Company Home Testing → Employees/Members list.
 * Every user of the current population appears (those who have never ordered a
 * kit show dashes and sort last); a row opens their kit profile.
 */
const CHomeTestingUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyHomeTestingUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home Testing — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and the kits they have ordered. Open a user
        to see where each kit is — never what it found.
      </p>

      <HomeTestingUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/home-testing/user?userId=${rowData?._id}`)}
        tableName="company_home_testing_users"
      />
    </div>
  );
};

export default CHomeTestingUsers;
